import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { PageTemplate } from "@omni/types/enums/pageTemplate.enum";
import { useSelector } from "react-redux";

import * as SearchSelectors from "@/redux/modules/value/search/search.selectors";
import { isPageTemplate } from "@/utils/pageTemplate.utils";
import { SearchComponent } from "@/utils/search/types/searchComponent";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const onSearchPage = isPageTemplate(PageTemplate.Search);

    const hasContentResults = useSelector(
        SearchSelectors.hasResults(SearchComponent.CONTENT_NUMBER_OF_HITS)
    );

    const renderContentResults = hasContentResults && onSearchPage;

    if (!renderContentResults) {
        return null;
    }

    return <>{children}</>;
};

export { Base };
